import {
  type ApiResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  PaymentGateway
} from './types/invoices.types';

export interface PaymentGatewaySetting {
  id: number
  gatewayKey: string
  isActive: boolean
  updatedBy: number | null
  createdAt: string
  updatedAt: string
}

/** Admin only. */
export async function listPaymentGatewaySettings(
  token: string
): Promise<ApiResponse<PaymentGatewaySetting[]>> {

  return apiRequest<ApiResponse<PaymentGatewaySetting[]>>('/payment-gateway-settings', undefined, token);
}

/** Admin only. */
export async function updatePaymentGatewaySetting(
  gatewayKey: PaymentGateway,
  isActive: boolean,
  token: string
): Promise<ApiResponse<PaymentGatewaySetting>> {

  return apiRequest<ApiResponse<PaymentGatewaySetting>>(
    `/payment-gateway-settings/${ gatewayKey }`,
    {
      method: 'PATCH',
      body: JSON.stringify({
        isActive
      })
    },
    token
  );
}

/** Public - no auth. Used by the checkout flow to know which gateways to offer. */
export async function getActivePaymentGateways(): Promise<ApiResponse<PaymentGateway[]>> {

  return apiRequest<ApiResponse<PaymentGateway[]>>('/payment-gateway-settings/active');
}
